import * as ActionTypes from 'ActionTypes'

export const setEntities = (entities) => {
  return {
    type: ActionTypes.SET_ENTITIES,
    payload: entities,
  } as const
}
